import React, { Component } from 'react'
import { ReactSpecimen } from 'catalog';
import Markup from './routingTool-markup'

class routingTool extends Component {
  constructor () {
    super()
    this.state = {
      single: false,
      swap: false,
      theme: ''
    }

    this.handleOptChange = this.handleOptChange.bind(this);
  }

  handleOptChange(event, stateName) {
    stateName === 'single' && this.setState({single: !this.state.single});
    stateName === 'swap' && this.setState({swap: !this.state.swap});
    stateName === 'theme' && this.setState({theme: event.target.value});
  }

  render () {
    return (
      <div className='page page-stage'>
        <section className='markup-container'>
          <div className='row'>
            <div className='col'>
              <h6>Swap content:</h6>
              <label>
                <input type='checkbox' onChange={(e) => this.handleOptChange(e, 'swap')} /> swap content
              </label>
            </div>
            <div className='col'>
              <h6>Single item:</h6>
              <label>
                <input type='checkbox' onChange={(e) => this.handleOptChange(e, 'single')} /> single item
              </label>
            </div>
            <div className='col'>
              <h6>Select a copy alignment:</h6>
              <select value={this.state.theme} onChange={(e) => this.handleOptChange(e, 'theme')}>
                <option value=''>copy center</option>
                <option value='top'>copy top</option>
                <option value='bottom'>copy bottom</option>
              </select>
            </div>
          </div>
          <br />
          <br />
          <div className='markup-container__inlay'>
            <Markup swap={this.state.swap} theme={this.state.theme} single={this.state.single}
            />
          </div>
        </section>
      </div>
    )
  }
}

export default routingTool;



// WEBPACK FOOTER //
// ./catalog/routingTool/routingTool.js